import React, { useState, useEffect } from 'react';
import { ArrowRight, Heart, ShieldCheck } from 'lucide-react';

// ✅ IMPORTACIONES CON RUTAS ABSOLUTAS
import { media } from 'theme/MediaLibrary';
import { branding } from 'theme/designSystem'; // Importamos el sistema de marca
import { useGlobal } from 'context/GlobalContext';

const LandingPage = ({ alIniciar }) => {
  // Traemos los documentos legales y configuraciones del contexto
  const { enlacesLegales = [] } = useGlobal(); 
  const [indexVersiculo, setIndexVersiculo] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndexVersiculo((prev) => (prev + 1) % media.textosBiblicos.length);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative h-screen w-full flex flex-col items-center justify-center overflow-hidden font-sans" style={{ backgroundColor: branding.casaDeFe.fondo }}>
      
      {/* FONDO DINÁMICO CON KEN BURNS EFFECT */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/90 via-slate-900/40 to-slate-900/95 z-10" />
        <img 
          src="/assets/images/fondo-iglesia.jpg" 
          className="h-full w-full object-cover animate-ken-burns" 
          alt="Fondo Casa de Fe" 
        />
      </div>

      {/* CUERPO CENTRAL */}
      <div className="relative z-20 text-center px-6 max-w-lg w-full flex-1 flex flex-col justify-center items-center">
        
        {/* LOGO Y BIENVENIDA */}
        <div className="bg-white/95 backdrop-blur-3xl p-10 md:p-14 rounded-[4rem] shadow-[0_40px_100px_-15px_rgba(0,0,0,0.5)] border border-white/40 transform transition-all duration-700 animate-in fade-in zoom-in-95">
          
          <div className="w-24 h-24 mx-auto mb-8 bg-slate-50 rounded-[2.5rem] flex items-center justify-center shadow-inner">
            <img src={media.logos.casaDeFe} className="h-16 object-contain" alt="Logo" />
          </div>
          
          <h1 className="text-4xl font-black tracking-tighter italic mb-2 uppercase leading-none" style={{ color: branding.casaDeFe.primario }}>
            Casa de Fe
          </h1>
          
          <p className="text-[10px] font-black uppercase tracking-[0.4em] mb-12 text-slate-400">
            Una vida de crecimiento
          </p>

          <button 
            onClick={alIniciar}
            className="w-full py-6 rounded-3xl text-white font-black text-xs uppercase tracking-[0.2em] shadow-2xl shadow-indigo-500/20 flex items-center justify-center gap-4 transition-all duration-300 active:scale-95 hover:brightness-110 group"
            style={{ backgroundColor: branding.casaDeFe.primario }}
          >
            Comenzar Recepción 
            <ArrowRight size={20} className="group-hover:translate-x-2 transition-transform" />
          </button>
        </div>

        {/* VERSÍCULOS INSPIRACIONALES */}
        <div className="mt-12 text-white animate-in slide-in-from-bottom-8 duration-1000 delay-300 max-w-sm">
          <div className="p-4 rounded-full bg-white/5 backdrop-blur-md border border-white/10 w-fit mx-auto mb-6">
            <Heart className="text-rose-400 animate-pulse" size={24} fill="currentColor" />
          </div>
          <div className="min-h-[100px] flex flex-col justify-center">
             <p className="italic font-bold text-xl leading-snug drop-shadow-lg tracking-tight">
                "{media.textosBiblicos[indexVersiculo].texto}"
             </p>
             <span className="text-[9px] font-black uppercase tracking-[0.4em] mt-6 block text-indigo-300 opacity-80">
                {media.textosBiblicos[indexVersiculo].cita}
             </span>
          </div>
        </div>
      </div>

      {/* FOOTER DE CUMPLIMIENTO (SINCRO ADMIN) */}
      <div className="relative z-20 w-full pb-10 pt-4 px-8 animate-in fade-in duration-1000 delay-500">
        <div className="flex flex-col items-center space-y-4">
          
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-[10px] font-black uppercase tracking-widest text-white/60">
            {enlacesLegales.length > 0 ? (
              enlacesLegales.map((enlace, index) => (
                <React.Fragment key={enlace.id}>
                  <a 
                    href={enlace.urlCompleta} 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white transition-colors cursor-pointer hover:scale-105"
                  >
                    {enlace.tituloHipervinculo}
                  </a>
                  {index < enlacesLegales.length - 1 && (
                    <span className="text-white/20">•</span>
                  )}
                </React.Fragment>
              ))
            ) : (
              <span className="text-white/20">POLÍTICAS DE PRIVACIDAD • TÉRMINOS DE USO</span>
            )}
          </div>

          <div className="flex items-center gap-2 text-white/30">
            <ShieldCheck size={14} />
            <p className="text-[8px] uppercase tracking-[0.3em] font-black">
              © {new Date().getFullYear()} CASA DE FE • SISTEMA DE SEGURIDAD INFANTIL IGLEKIDS
            </p>
          </div>
        </div>
      </div>

    </div>
  );
};

export default LandingPage;